var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadTickWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.410034 8.41008L6.00003 14.0001L7.41003 12.5801L1.83003 7.00008M22.24 0.580078L11.66 11.1701L7.50003 7.00008L6.07003 8.41008L11.66 14.0001L23.66 2.00008M18 2.00008L16.59 0.580078L10.24 6.93008L11.66 8.34008L18 2.00008Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadTickWhiteIcon);
export default __webpack_public_path__ + "static/media/read-tick-white-icon.c859668ee4b605e53ec6e3564ca3401f.svg";
export { ForwardRef as ReactComponent };